module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_4.ccc438e7.jpg";